// @ts-nocheck
import type * as Types from '@lingoda/monolith-graphql/src/generated';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
import { PriceFragmentDoc } from '../../monolith-graphql/src/fragments/price.generated';
import { IntervalFragmentDoc } from '../../monolith-graphql/src/fragments/interval.generated';
export type UserSubscriptionBaseFragment = {
    readonly __typename?: 'UserSubscription';
    readonly id: number;
    readonly status: Types.SubscriptionStatus;
    readonly isInTrial: boolean;
    readonly isRecurring: boolean;
    readonly activatedAt: string | null;
    readonly createdAt: string | null;
    readonly expiresAt: string | null;
    readonly expired: boolean;
    readonly title: string;
    readonly type: Types.SubscriptionType;
    readonly purchaseType: Types.PurchaseType;
    readonly productType: string | null;
    readonly origin: Types.SubscriptionOrigin;
    readonly couponCode: string | null;
    readonly privateCredits: number;
    readonly groupCredits: number;
    readonly lastChargedAt: string | null;
    readonly nextChargeAt: string | null;
    readonly nextEffectiveChargeDate: string | null;
    readonly onPaymentRetrySchedule: boolean;
    readonly nextPaymentRetryAt: string | null;
    readonly pausedAt: string | null;
    readonly resumesAt: string | null;
    readonly startDelayedUntil: string | null;
    readonly externalSubscriptionId: string | null;
    readonly currentFreeTrialDay: number | null;
    readonly productId: number | null;
    readonly price: {
        readonly __typename?: 'Price';
        readonly currency: Types.Currency;
        readonly amount: number;
        readonly amountInMajor: number;
        readonly forHumans: string;
    };
    readonly recurrenceInterval: {
        readonly __typename?: 'DateInterval';
        readonly years: number;
        readonly months: number;
        readonly weeks: number;
        readonly days: number;
        readonly hours: number;
        readonly minutes: number;
        readonly seconds: number;
        readonly microseconds: number;
        readonly forHumans: string;
    } | null;
    readonly creditsValidityInterval: {
        readonly __typename?: 'DateInterval';
        readonly years: number;
        readonly months: number;
        readonly weeks: number;
        readonly days: number;
        readonly hours: number;
        readonly minutes: number;
        readonly seconds: number;
        readonly microseconds: number;
        readonly forHumans: string;
    } | null;
};

export type UserSubscriptionActionsFragment = {
    readonly __typename?: 'UserSubscription';
    readonly id: number;
    readonly canChange: boolean;
    readonly canPause: boolean;
    readonly canUnpause: boolean;
    readonly canCancel: boolean;
    readonly canUncancel: boolean;
    readonly canReactivate: boolean;
    readonly canStartNew: boolean;
    readonly canStartNextNow: boolean;
    readonly canCancelTrial: boolean;
    readonly canSkipTrial: boolean;
    readonly subscribeNow: boolean;
    readonly pauseScheduled: boolean;
    readonly paymentNeeded: boolean;
    readonly paymentMethodAdded: boolean | null;
};

export type UserSubscriptionContentFragment = {
    readonly __typename?: 'UserSubscription';
    readonly id: number;
    readonly contentBlocks: ReadonlyArray<{
        readonly __typename?: 'ContentBlock';
        readonly text: string;
        readonly location: Types.Location;
        readonly label: string | null;
        readonly icon: Types.Icon | null;
        readonly table: string[][] | null;
        readonly isStarred: boolean;
    }>;
};

export type UserSubscriptionFullFragment = {
    readonly __typename?: 'UserSubscription';
    readonly id: number;
    readonly status: Types.SubscriptionStatus;
    readonly isInTrial: boolean;
    readonly isRecurring: boolean;
    readonly activatedAt: string | null;
    readonly createdAt: string | null;
    readonly expiresAt: string | null;
    readonly expired: boolean;
    readonly title: string;
    readonly type: Types.SubscriptionType;
    readonly purchaseType: Types.PurchaseType;
    readonly productType: string | null;
    readonly origin: Types.SubscriptionOrigin;
    readonly couponCode: string | null;
    readonly privateCredits: number;
    readonly groupCredits: number;
    readonly lastChargedAt: string | null;
    readonly nextChargeAt: string | null;
    readonly nextEffectiveChargeDate: string | null;
    readonly onPaymentRetrySchedule: boolean;
    readonly nextPaymentRetryAt: string | null;
    readonly pausedAt: string | null;
    readonly resumesAt: string | null;
    readonly startDelayedUntil: string | null;
    readonly externalSubscriptionId: string | null;
    readonly currentFreeTrialDay: number | null;
    readonly productId: number | null;
    readonly canChange: boolean;
    readonly canPause: boolean;
    readonly canUnpause: boolean;
    readonly canCancel: boolean;
    readonly canUncancel: boolean;
    readonly canReactivate: boolean;
    readonly canStartNew: boolean;
    readonly canStartNextNow: boolean;
    readonly canCancelTrial: boolean;
    readonly canSkipTrial: boolean;
    readonly subscribeNow: boolean;
    readonly pauseScheduled: boolean;
    readonly paymentNeeded: boolean;
    readonly paymentMethodAdded: boolean | null;
    readonly price: {
        readonly __typename?: 'Price';
        readonly currency: Types.Currency;
        readonly amount: number;
        readonly amountInMajor: number;
        readonly forHumans: string;
    };
    readonly recurrenceInterval: {
        readonly __typename?: 'DateInterval';
        readonly years: number;
        readonly months: number;
        readonly weeks: number;
        readonly days: number;
        readonly hours: number;
        readonly minutes: number;
        readonly seconds: number;
        readonly microseconds: number;
        readonly forHumans: string;
    } | null;
    readonly creditsValidityInterval: {
        readonly __typename?: 'DateInterval';
        readonly years: number;
        readonly months: number;
        readonly weeks: number;
        readonly days: number;
        readonly hours: number;
        readonly minutes: number;
        readonly seconds: number;
        readonly microseconds: number;
        readonly forHumans: string;
    } | null;
    readonly contentBlocks: ReadonlyArray<{
        readonly __typename?: 'ContentBlock';
        readonly text: string;
        readonly location: Types.Location;
        readonly label: string | null;
        readonly icon: Types.Icon | null;
        readonly table: string[][] | null;
        readonly isStarred: boolean;
    }>;
};

export const UserSubscriptionBaseFragmentDoc = gql`
    fragment UserSubscriptionBase on UserSubscription {
        id
        status
        isInTrial
        isRecurring
        activatedAt
        createdAt
        expiresAt
        expired
        title
        type
        purchaseType
        productType
        origin
        couponCode
        privateCredits
        groupCredits
        price {
            ...price
        }
        recurrenceInterval {
            ...interval
        }
        creditsValidityInterval {
            ...interval
        }
        lastChargedAt
        nextChargeAt
        nextEffectiveChargeDate
        onPaymentRetrySchedule
        nextPaymentRetryAt
        pausedAt
        resumesAt
        startDelayedUntil
        externalSubscriptionId
        currentFreeTrialDay
        productId
    }
    ${PriceFragmentDoc}
    ${IntervalFragmentDoc}
` as unknown as DocumentNode<UserSubscriptionBaseFragment, unknown>;
export const UserSubscriptionActionsFragmentDoc = gql`
    fragment UserSubscriptionActions on UserSubscription {
        id
        canChange
        canPause
        canUnpause
        canCancel
        canUncancel
        canReactivate
        canStartNew
        canStartNextNow
        canCancelTrial
        canSkipTrial
        subscribeNow
        pauseScheduled
        paymentNeeded
        paymentMethodAdded
    }
` as unknown as DocumentNode<UserSubscriptionActionsFragment, unknown>;
export const UserSubscriptionContentFragmentDoc = gql`
    fragment UserSubscriptionContent on UserSubscription {
        id
        contentBlocks {
            text
            location
            label
            icon
            table
            isStarred
        }
    }
` as unknown as DocumentNode<UserSubscriptionContentFragment, unknown>;
export const UserSubscriptionFullFragmentDoc = gql`
    fragment UserSubscriptionFull on UserSubscription {
        id
        ...UserSubscriptionBase
        ...UserSubscriptionActions
        ...UserSubscriptionContent
    }
    ${UserSubscriptionBaseFragmentDoc}
    ${UserSubscriptionActionsFragmentDoc}
    ${UserSubscriptionContentFragmentDoc}
` as unknown as DocumentNode<UserSubscriptionFullFragment, unknown>;
